import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ErrorStateComponent } from '../page-states/error-state.component';

/**
 * Full-viewport boot-failure surface: the tenant config (/api/config) could not be
 * loaded even after retries. The app shell cannot start without it — storage URLs,
 * languages and brand identity all come from the tenant and have NO meaningful
 * defaults — so the app root mounts this INSTEAD of the shell. Retry reloads the
 * page, which re-runs the config fetch during bootstrap.
 */
@Component({
  selector: 'app-config-error',
  standalone: true,
  imports: [ErrorStateComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="config-error-viewport">
      <app-error-state
        titleKey="configError.title"
        descKey="configError.description"
        (retry)="reload()" />
    </div>
  `,
  styles: [`
    .config-error-viewport {
      display: flex;
      flex-direction: column;
      height: 100vh;
    }
  `],
})
export class ConfigErrorComponent {
  protected reload(): void {
    window.location.reload();
  }
}
